import React from "react";
import { BrowserRouter as Router } from "react-router-dom";
import AppRoute from "./Route.jsx";
import "bootstrap/dist/css/bootstrap.min.css";
import "./app.scss";



const App = () => {
  return (
    <div className="main-container">
      <Router>
        <AppRoute />
      </Router>
    </div>
  );
};


export default App;

